import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VbPaymentChangeLumpSumCardVariant } from './vb-payment-change-lump-sum-card/vb-payment-change-lump-sum-card.component';
import { LumpSumPaymentInstruction } from '../../../../../models/transactions/lump-sum-payment-instruction';
import { VbScheduledChangeNotice } from '../../create-vb-payment-change-components/utils/vb-payment-change-review-step.utils';

@Component({
  selector: 'app-vb-payment-change-submission-lump-sum-details-card',
  templateUrl: './vb-payment-change-submission-lump-sum-details-card.component.html',
  styleUrls: ['./vb-payment-change-submission-lump-sum-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionLumpSumDetailsCardComponent implements OnChanges {
  @Input({ required: true }) currentLumpSumPaymentInstruction!: LumpSumPaymentInstruction | null;
  @Input({ required: true }) newLumpSumPaymentInstruction!: LumpSumPaymentInstruction | null;
  @Input({ required: true }) currentForgoRecurringPayments!: boolean;
  @Input({ required: true }) newForgoRecurringPayments!: boolean;
  @Input() scheduledChangeNotice: VbScheduledChangeNotice | null = null;

  public readonly CardVariant = VbPaymentChangeLumpSumCardVariant;

  public hasChanged = false;
  public isCurrentBlank = false;
  public isNewBlank = false;

  public ngOnChanges(): void {
    this.hasChanged = !!this.newLumpSumPaymentInstruction;

    const datesMatch =
      this.currentLumpSumPaymentInstruction?.desiredPaymentDate?.split('T')[0] ===
      this.newLumpSumPaymentInstruction?.desiredPaymentDate?.split('T')[0];

    this.isCurrentBlank =
      !this.currentLumpSumPaymentInstruction ||
      (datesMatch && this.currentLumpSumPaymentInstruction.paymentAmount === 0);

    this.isNewBlank =
      !this.newLumpSumPaymentInstruction || (datesMatch && this.newLumpSumPaymentInstruction.paymentAmount === 0);
  }
}
